import { useEffect } from 'react';

export default function ProductionTagManager() {
  useEffect(() => {
    // CookieYes lives inside this container, so keep it available promptly.
    // Never load the domain-registered banner on preview/editor hosts.
    if (!['enkelenergi.dk', 'www.enkelenergi.dk'].includes(window.location.hostname) || window.__GTM_LOADED__) return;
    window.__GTM_LOADED__ = true;
    window.dataLayer = window.dataLayer || [];
    const gtag = window.gtag || function () { window.dataLayer.push(arguments); };
    gtag('consent', 'default', {
      analytics_storage: 'denied', ad_storage: 'denied',
      ad_user_data: 'denied', ad_personalization: 'denied',
    });
    // The existing CookieYes integration supplies saved choices and updates.
    window.dataLayer.push({ 'gtm.start': Date.now(), event: 'gtm.js' });
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://www.googletagmanager.com/gtm.js?id=GTM-P83BZ9C8';
    document.head.appendChild(script);
    if (!document.getElementById('gtm-noscript')) {
      const noscript = document.createElement('noscript');
      noscript.id = 'gtm-noscript';
      const iframe = document.createElement('iframe');
      iframe.src = 'https://www.googletagmanager.com/ns.html?id=GTM-P83BZ9C8';
      iframe.height = '0'; iframe.width = '0';
      iframe.style.display = 'none'; iframe.style.visibility = 'hidden';
      noscript.appendChild(iframe);
      document.body.insertBefore(noscript, document.body.firstChild);
    }
  }, []);
  return null;
}